import { TEL_HREF, WHATSAPP_HREF, PHONE_DISPLAY } from "@/lib/ascentix";
import Wordmark from "@/components/Wordmark";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-900 text-amber-50/85"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Wordmark size="lg" invert showSubtitle />
            <p className="mt-6 text-[15px] leading-relaxed max-w-md text-amber-50/70">
              Ascentix Development Limited — equipping professionals and teams
              for peak performance through leadership, business growth and
              digital capability training.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow !text-amber-400">Explore</div>
            <ul className="mt-5 space-y-3 text-[15px]">
              {[
                ["About", "about"],
                ["Programmes", "programmes"],
                ["Approach", "approach"],
                ["Clients", "clients"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    onClick={() =>
                      document.getElementById(id)?.scrollIntoView({
                        behavior: "smooth",
                      })
                    }
                    data-testid={`footer-link-${id}`}
                    className="hover:text-amber-300 transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow !text-amber-400">Get in touch</div>
            <ul className="mt-5 space-y-3 text-[15px]">
              <li>
                <a
                  href={TEL_HREF}
                  data-testid="footer-tel"
                  className="hover:text-amber-300 transition-colors"
                >
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_HREF}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-amber-300 transition-colors"
                >
                  WhatsApp Ascentix
                </a>
              </li>
              <li>
                <button
                  onClick={() =>
                    document.getElementById("contact")?.scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                  data-testid="footer-enquiry"
                  className="hover:text-amber-300 transition-colors text-left"
                >
                  Send an enquiry
                </button>
              </li>
              <li className="text-amber-50/60 text-[14px]">
                17a Awolowo Road, Ikoyi, Lagos.
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[13px] text-amber-50/60">
          <div>© {year} Ascentix Development Limited. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span className="size-1.5 rounded-full bg-orange-500" />
            Equipping professionals for peak performance.
          </div>
        </div>
      </div>
    </footer>
  );
}
